var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HearingAbilityContent } from '@/components/hearing-ability-content.component';
import { useStyledModal } from '@/hooks/use-styled-modal.hook';
import { ButtonBase, Typography } from '@mui/material';
import { useAnalytics } from 'hx-analytics';
export function HearingResultsPopup() {
    var _a = useStyledModal(_jsx(HearingAbilityContent, {})), modal = _a[0], toggleModal = _a[1];
    var sendButtonClick = useAnalytics().sendButtonClick;
    function onClick() {
        toggleModal();
        sendButtonClick('result_explainer');
    }
    return (_jsxs("div", __assign({ className: 'flex flex-col my-2 md:my-8 items-center justify-center gap-2' }, { children: [modal, _jsx(ButtonBase, __assign({ onClick: onClick }, { children: _jsx(Typography, __assign({ className: "text-eargo-blice-blue underline text-lg text-center" }, { children: "Learn more about my results" })) }))] })));
}
